import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import { getStatisticsSuccess, getStatisticsPrevYearSuccess } from '../actions/Statistics'

import { GET_STATISTICS } from '../constants/ActionsTypes'

import { getStatisticsRequest } from '../api/Statistics'

function* getStatistics({ payload }) {
  const { clientCode, dateFrom, dateTo, pageSize, page } = payload
  try {
    const data = yield call(getStatisticsRequest, clientCode, dateFrom, dateTo, pageSize, page)
    if (data && data.response) {
      const current = data.response.current ? data.response.current.return : []
      const previousPeriod = data.response.previousPeriod ? data.response.previousPeriod.return : []
      yield put(getStatisticsSuccess(current))
      yield put(getStatisticsPrevYearSuccess(previousPeriod))
    }
  } catch (error) {
    // handled in interceptor
  }
}

export function* getStatisticsSaga() {
  yield takeLatest(GET_STATISTICS, getStatistics)
}

export default function* rootSaga() {
  yield all([fork(getStatisticsSaga)])
}
